import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/browser';
import ReactGA from 'react-ga4';
import ErrorBoundary from './ErrorBoundary';
import { Integrations } from '@sentry/tracing';

if (process.env.NODE_ENV === 'production') {
  // SENTRY
  Sentry.init({
    ignoreErrors: ['Non-Error promise rejection captured'],
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.5,
  });

  // GOOGLE ANALYTICS
  ReactGA.initialize(process.env.REACT_APP_ANALYTICS_ID);
}

ReactDOM.render(
  <ErrorBoundary>
    <React.StrictMode>
      <App ReactGA={ReactGA} />
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
